import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";

console.log('[SENTRY] Initializing with DSN:', import.meta.env.VITE_SENTRY_DSN ? 'Present' : 'MISSING');

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
  beforeSend(event, hint) {
    const error = hint.originalException;
    const supabaseCode = error && typeof error === 'object' ? (error as any).code : undefined;

    // Normalize Supabase/PostgREST error objects.
    // Only real Postgres/PostgREST errors carry a non-empty string `code`.
    // Network-level failures from supabase-js arrive as `code: ''` with the
    // client-side JS stack in `details`, so they must NOT be branded as a
    // SupabaseError nor reported as a DB detail.
    if (
      error &&
      typeof error === 'object' &&
      'message' in error &&
      typeof supabaseCode === 'string' &&
      supabaseCode !== ''
    ) {
      const supabaseMessage = (error as any).message;
      const supabaseDetails = (error as any).details;
      const supabaseHint = (error as any).hint;

      event.exception = event.exception || {};
      event.exception.values = event.exception.values || [];

      if (event.exception.values.length > 0) {
        event.exception.values[0].type = `SupabaseError [${supabaseCode}]`;
        event.exception.values[0].value = supabaseMessage;
      } else {
        event.exception.values.push({
          type: `SupabaseError [${supabaseCode}]`,
          value: supabaseMessage,
        });
      }

      event.tags = {
        ...event.tags,
        supabase_code: supabaseCode,
      };
      event.extra = {
        ...event.extra,
        supabase_details: supabaseDetails,
        supabase_hint: supabaseHint,
      };
    }
    return event;
  },
});

createRoot(document.getElementById("root")!).render(
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
);
